module.exports = __webpack_public_path__ + "img/number_order2.819fa563.svg";